import { render, staticRenderFns } from "./appUpload.vue?vue&type=template&id=ecfa939c&scoped=true&"
import script from "./appUpload.vue?vue&type=script&lang=js&"
export * from "./appUpload.vue?vue&type=script&lang=js&"
import style0 from "./appUpload.vue?vue&type=style&index=0&id=ecfa939c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecfa939c",
  null
  
)

component.options.__file = "appUpload.vue"
export default component.exports